module.exports = __webpack_public_path__ + "_/_/src/assets/firesafety/Smoke-Detector-V2/legend.png";